import React from 'react'
import { useSelector } from 'react-redux'

import ArticleTemplate from '../../templates/Article'
import { selectors as AppSelectors } from '../../redux/app/redux'
import withMemo from '../../decorators/WithMemo'

import PostDetailsSagas from './sagas'
import { selectors } from './redux'


const Article = () => {
  const data = useSelector(selectors.data)
  const breadcrumb = useSelector(AppSelectors.breadcrumb)

  return (
    <ArticleTemplate
      data={data}
      breadcrumb={breadcrumb}
    />
  )
}

Article.getInitialProps = async(ctx, store) => (
  store.saga.run(PostDetailsSagas.init, ctx).done
)

Article.propTypes = {}

export default withMemo()(Article)
